import { Helmet } from "react-helmet";
import FloatingHireRequestButton from "./components/FloatingHireRequestButton";
import HireArchitectureSection from "./components/HireArchitectureSection";
import HireCaseStudySection from "./components/HireCaseStudySection";
import HireCompressionSection from "./components/HireCompressionSection";
import HireHeaderSection from "./components/HireHeaderSection";
import HireInfrastructureSection from "./components/HireInfrastructureSection";
import HireLogoStripSection from "./components/HireLogoStripSection";
import HireModelsSection from "./components/HireModelsSection";
import HireProcessSection from "./components/HireProcessSection";
import HireRequestBannerSection from "./components/HireRequestBannerSection";
import HireRequestFormSection from "./components/HireRequestFormSection";
import HireRoleRailSection from "./components/HireRoleRailSection";
import HireRolesSection from "./components/HireRolesSection";
import HireTalentGridSection from "./components/HireTalentGridSection";
import HireTalentPhotoStorySection from "./components/HireTalentPhotoStorySection";
import HireTransformationSection from "./components/HireTransformationSection";
import OurStrategySection from "./components/OurStrategySection";
import SiteFooter from "../../components/layout/SiteFooter";

const Hire = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Hire Assessed Global Talent</title>
      </Helmet>

      <HireHeaderSection />
      <HireLogoStripSection />
      <HireRoleRailSection />
      <OurStrategySection />
      <HireModelsSection />
      <HireCompressionSection />
      <HireCaseStudySection />
      <HireArchitectureSection />
      <HireInfrastructureSection />
      <HireTalentGridSection />
      <HireRolesSection />
      <HireTalentPhotoStorySection />
      <HireTransformationSection />
      <HireProcessSection />
      <HireRequestFormSection />
      <HireRequestBannerSection />

      <FloatingHireRequestButton />

      <SiteFooter />
    </div>
  );
};

export default Hire;
